<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="w-50 d-block m-auto w-xs-100 w-sm-100 w-md-100 w-ipad-100 rounded-3 bg-white mt-xl-5 mt-4 mb-xl-5 mb-4 p-3 pt-xl-4 pb-xl-4 pb-3 pt-3">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="w-100 d-inline-block text-center">
                <!-- <img class="back-me-image" v-lazy="require('@/assets/images/back-home-image.png')" alt=""> -->
                <img class="back-me-image" src="@/assets/images/back-home-image.png" alt="">
                  <h1 class="mb-0 text-size-14 text-black filson-black-family fw-bold margin-top-3 text-full-14">
                    {{ customerName }}
                  </h1>
                  <p class="mb-0 text-size-14 text-black inter-regular-family margin-top-2 
                  text-full-13">
                    We appreciate your trust in our services and glad to be a part of your pet's health journey. We look forward to servicing you again. Happy pet grooming session!
                  </p>
                  <div class="w-100 d-inline-block text-center margin-top-3 position-relative">
                      <!-- <img class="pdf-image position-absolute" v-lazy="require('@/assets/images/pdf-image.png')" alt=""> -->
                      <img class="pdf-image position-absolute" src="@/assets/images/pdf-image.png" alt="">
                      <a class="bg-introduction text-size-14 nav-color fw-bold filson-black-family download-btn d-inline-block position-relative padding-3 
                      margin-left-4 text-full-13" href="javascript:void(0)"
                       @click="downloadBookingPDF"
                       >
                        <span>Download Booking Details
                        </span>
                      </a>
                  </div>
                  <div class="w-100 d-inline-block text-center margin-top-2 margin-bottom-3">
                  <router-link class="text-white text-size-14 bg-green border-green rounded-5 inter-semi-bold text-uppercase padding-top-2 padding-bottom-2 padding-right-4 padding-left-4 d-inline-block text-full-13" to="/">Back to home
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'backHomeBannerComponent',
   props: {
    customerName: {
      type: String,
      required: true
    },
    bookingId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {

    };
  },
  methods: {
    async downloadBookingPDF() {
      try {
        const response = await this.$axios.get(`/download-booking/${this.bookingId}`, {
          responseType: 'blob' // Ensure the response is treated as a file
        });

        // Create a Blob URL for the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'booking_details.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.$toast.success('Booking PDF downloaded successfully!');
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.$toast.error('Failed to download booking details.');
      }
    }
  }
}
</script>

<style scoped>
</style>
